import * as React from 'react';
import { observer } from 'mobx-react';
import SharedHeadColumns from '../SharedHeadColumns';
import { T } from '../../../../../Translations';

const Head: React.FC = () => (
  <thead className="bg-gray-50">
    <tr>
      <SharedHeadColumns />
      <th className="px-3 py-3.5 text-left text-xs font-semibold text-gray-900 lg:table-cell">
        <T kind="Status" />
      </th>
    </tr>
  </thead>
);

export default observer(Head);
